import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { ColProps } from '../Col/Col';

export interface GridProps {
  children: ReactElement<ColProps> | Array<ReactElement<ColProps>>;
  className?: string;
  gapX?: string;
  gapY?: string;
  dir?: string;
}

const Grid: React.FC<GridProps> = ({ children, className, gapX, gapY }) => {
  return (
    <div
      className={classNames(
        gapX || 'gap-x-6',
        gapY || 'gap-y-12 md:gap-y-10',
        'grid grid-cols-12',
        className
      )}
    >
      {children}
    </div>
  );
};

export default Grid;
